import { render } from "./ProgramView.vue?vue&type=template&id=78dc4f03"
const script = {}

import "./ProgramView.vue?vue&type=style&index=0&id=78dc4f03&lang=css"

import exportComponent from "D:\\Backup\\Sunville\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__